const MarketDataGraphModel = {
  state: {
    marketGraphModalEventData: null,
    showMarketGraphModal: false,
    marketGraphModalRunner: null,
    marketGraphModalMarket: null,
  },
  reducers: {
    setMarketGraphModalEvent: (state: Record<string, any>, payload: any) => {
      return { ...state, MarketGraphModalEvent: payload };
    },
    openMarketGraphModal: (
      state: Record<string, any>,
      payload: Record<string, any>
    ) => {
      return {
        ...state,
        showMarketGraphModal: true,
        marketGraphModalEventData: payload.eventData,
        marketGraphModalRunner: payload.runnerToDisplay,
        marketGraphModalMarket: payload.marketToDisplay,
      };
    },
    closeMarketGraphModal: (state: Record<string, any>) => {
      return {
        ...state,
        showMarketGraphModal: false,
        marketGraphModalEventData: null,
        marketGraphModalRunner: null,
        marketGraphModalMarket: null,
      };
    },
  },
  effects: {},
};
export default MarketDataGraphModel;
